'use server';
import { ApiResponse } from "@/types/api";
import { getTranslations } from "next-intl/server";
import { cookies } from "next/headers";
import z from "zod";

const schema = z.object({
    license: z.string().min(1, "auth.license"),
    password: z.string().min(8, "auth.password"),
    email: z.string().regex(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "auth.email"),
    firstname: z.string().min(2, "auth.firstname"),
    lastname: z.string().min(2, "auth.lastname"),
    birthdate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "auth.birthdate")
})
export async function registerAction(
    state: ApiResponse<string | undefined> | undefined,
    formData: FormData
): Promise<ApiResponse<string | undefined> | undefined>{
    const t = await getTranslations("error");

    if (formData.get("password") !== formData.get("confirmPassword")){
        return {
            success: false,
            error: t("auth.passwordmatch")
        }
    }

    const parsed = schema.safeParse({
        license: formData.get("license"),
        password: formData.get("password"),
        email: formData.get("email"),
        firstname: formData.get("firstname"),
        lastname: formData.get("lastname"),
        birthdate: formData.get("birthdate")
    })

    if (!parsed.success){
        return {
            success: false,
            error: t(parsed.error.issues[0].message)
        }
    }

    const date = new Date(parsed.data.birthdate);
    const today = new Date();
    const age = today.getTime() - date.getTime();

    if (age < 12 * 365 * 24 * 60 * 60 * 1000 || age > 120 * 365 * 24 * 60 * 60 * 1000) {
        return {
            success: false,
            error: t("auth.age")
        }
    }

    const res = await fetch(process.env.NEXT_PRIVATE_API_URL + "/auth/register", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(parsed.data)
    })

    if (res.status == 500) {
        return {
            success: false,
            error: t("serverError")
        }
    }


    const resjson: ApiResponse<string> = await res.json();

    if(!resjson.success || !resjson.data){
        if(resjson.error){
            return {
                success: false,
                error: t(resjson.error)
            }
        }

        return {
            success: false,
            error: t("serverError")
        }
    }
    
    const cookieStore = await cookies();

    cookieStore.set("refreshT", resjson.data, {
        secure: true,
        httpOnly: true,
        sameSite: "strict",
        maxAge: 60 * 60 * 24 * 30
    })

    return {
        success: true,
        data: "success"
    }

}